import { Component, Input, OnChanges, Output, EventEmitter } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { BaseLink } from "../../models/base-link";

@Component({
  selector: "app-list-links",
  templateUrl: "./list-links.component.html",
  styleUrls: ["./list-links.component.scss"],
})
export class ListLinksComponent implements OnChanges {

    @Input() public items: BaseLink[];
    @Input() public headingText: string;
    @Input() public showHeader: boolean = true;
    @Input() public showSearch: boolean = false;
    @Input() public searchKey: string = "title";
    @Input() public externalFilter: any;
    @Output() public filterValueChange: EventEmitter<string> = new EventEmitter();

    public searchTextFilterObject: any;

    constructor(private router: Router,
                private route: ActivatedRoute) {

    }

    public ngOnChanges(): void {
      if (this.externalFilter !== undefined) {
        this.searchTextChanged(this.externalFilter);
      }
    }

    public searchTextChanged(value) {
        const filter = {};
        filter[this.searchKey] = value;
        this.searchTextFilterObject = filter;
        this.filterValueChange.emit(value);
    }

}
